import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { api } from "./api";
import { DEFAULT_MEDIA } from "./media";

// SiteContentProvider — haalt beheer-bare content op (rooster, mededeling, banners, teaser, tekst-overrides).
// Bij een API-fout valt de site terug op de ingebouwde standaardteksten.
const ContentCtx = createContext({ content: null, refreshContent: async () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refreshContent = useCallback(async () => {
    try {
      const { data } = await api.get("/site/content");
      setContent(data);
    } catch {
      // bewust stil: de site blijft werken met standaardcontent
    }
  }, []);

  useEffect(() => { refreshContent(); }, [refreshContent]);

  const value = useMemo(() => ({ content, refreshContent }), [content, refreshContent]);
  return <ContentCtx.Provider value={value}>{children}</ContentCtx.Provider>;
}

export function useSiteContent() {
  return useContext(ContentCtx);
}

// useMedia() — geeft media(key) terug: admin-override (upload/link) of de standaard.
export function useMedia() {
  const { content } = useSiteContent();
  const overrides = content?.image_overrides || {};
  return useCallback((key) => {
    const v = overrides[key];
    if (typeof v === "string" && v.trim()) return v;
    return DEFAULT_MEDIA[key] || "";
  }, [overrides]);
}
